import React, { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./TextEditor.css";

export default function TextEditor({ value, onSave, onClose }) {

    const [content, setContent] = useState(value || "");
    const [length, setLength] = useState(0);

    const handleChange = (content, delta, source, editor) => {
        setContent(content);

        const text = editor.getText().trim(); // texte brut sans espaces superflus
        const words = text.split(/\s+/).filter(word => word.length > 0); // séparer par espaces, tab, saut de ligne
        setLength(words.length); // ici on stocke le nombre de mots
    };

    const modules = {
        toolbar: [
            [{ font: [] }, { size: [] }],
            [{ header: [1, 2, 3, false] }],
            ["bold", "italic", "underline", "strike"],
            [{ color: [] }, { background: [] }],
            [{ script: "sub" }, { script: "super" }],
            [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ align: [] }],
            [],
            [],
            []
        ]
    };

    const handleSave = () => {
        onSave(content);
        onClose();
    };

    return (
        <div className="editor-modal">

            <div className="editor-container">

                <div className="editor-header">
                    <div className="text-editor-title">
                        <span class="material-symbols-outlined">
                            edit_square
                        </span>
                        <h3>Description de l'événement</h3>
                    </div>

                    <button className="modal-close-icon" onClick={onClose}>
                        <span class="material-symbols-outlined">
                            close
                        </span>
                    </button>
                </div>

                <div className="text-editor-container">
                    <ReactQuill
                        theme="snow"
                        value={content}
                        onChange={handleChange}
                        modules={modules}
                        className="editor"
                    />
                    <div className="count-length">
                        <span>{length} mots</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
                            <path d="M3.58789 3.58789L6.88078 0.294999C7.51075 -0.334966 8.58789 0.111199 8.58789 1.0021V5.58789C8.58789 7.24474 7.24474 8.58789 5.58789 8.58789H1.0021C0.111199 8.58789 -0.334967 7.51075 0.294997 6.88078L3.58789 3.58789Z" fill="#52525B" />
                        </svg>
                    </div>
                </div>


                <div className="editor-actions">

                    <button className="btn-light" onClick={onClose}>
                        Annuler
                    </button>

                    <button className="btn-green" onClick={handleSave}>
                        Enregistrer
                    </button>

                </div>

            </div>

        </div>
    );
}